import { render, staticRenderFns } from "./IndexChart.vue?vue&type=template&id=bf7b3666&scoped=true"
import script from "./IndexChart.vue?vue&type=script&lang=js"
export * from "./IndexChart.vue?vue&type=script&lang=js"
import style0 from "./IndexChart.vue?vue&type=style&index=0&id=bf7b3666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b3666",
  null
  
)

export default component.exports